module.exports = __webpack_public_path__ + "macbook-wtr.14d397125fbeea963a98149a810d3603.png";